import { WEB_EMBED_SCRIPT } from 'env';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function PreviewLink() {
  const { agent } = useParams();

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${WEB_EMBED_SCRIPT}"]`);

    if (!existingScript) {
      const script1 = document.createElement('script');
      script1.src = WEB_EMBED_SCRIPT ?? '';
      script1.id = 'embed-script';
      script1.async = true;
      script1.onload = () => {
        if ((window as any).VoiceBot && !(window as any).VoiceBot.isOpened) {
          (window as any).VoiceBot?.open({ agentToken: agent, isForPreview: true, isPreviewLink: true });
          (window as any).VoiceBot.isOpened = true;
        }
      };
      document.head.appendChild(script1);
      return () => {
        document.head.removeChild(script1);
      };
    } else {
      if ((window as any).VoiceBot && !(window as any).VoiceBot.isOpened) {
        (window as any).VoiceBot?.open({ agentToken: agent, isForPreview: true, isPreviewLink: true });
        (window as any).VoiceBot.isOpened = true;
      }
    }
  }, [agent]);

  return <></>;
}
